import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity } from '../common/entity';
import { EntityAuthorization } from '../common/entityAuthorization';
import { CompanyRole } from '../company_role_assignment/companyRoleAssignment';

export class KitProduct {
  productMasterDataId: string;
  quantity: number;

  constructor(productMasterDataId: string, quantity: number) {
    this.productMasterDataId = productMasterDataId;
    this.quantity = quantity;
  }
}

export class KitTemplate extends CompanyEntity {
  name!: string;
  productMasterDataId!: string;
  products: KitProduct[] = [];

  authorization = new KitTemplateAuthorization();

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }
}

export class KitTemplateAuthorization extends EntityAuthorization<KitTemplate> {
  forCreate = () => CompanyRole.administrator;
  forUpdate = () => CompanyRole.administrator;
  forDelete = () => CompanyRole.administrator;
  forGet = () => CompanyRole.employee;
}
